module.exports = kolibriCoreAppGlobal.utils.redirectBrowser;